import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHttp } from "./useHttp";
import { createSetQuoteAction } from "../actions/dataActions";

export const useQuoteData = (id, dataFresh) => {
  let nofetch = !id;
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp(
    `quotes/${id}`,
    "get",
    {},
    dataFresh,
    nofetch
  );
  if (error) {
    throw Error("There was an error");
  }
  // undefined until the first fetch result reaches the store - "loaded" waits for that
  // so the screen never renders against an empty/previous record
  const [synced, setSynced] = useState(undefined);
  // Dispatch only when the fetch result changes - not in the render body, where every
  // re-render re-dispatched (wiping unsaved edits) and could loop (React error #301).
  useEffect(() => {
    if (!loading && data !== null) {
      dispatch(createSetQuoteAction(data));
    } else {
      dispatch(
        createSetQuoteAction({
          vehicle: {},
          comments: "",
          workshop: {},
          customer: {},
          need_date: "",
          start_date: "",
          estimated_work_items: [],
          comments_list: [],
          customer_vehicle: false,
          department: {id: 5, name:"RAPID FIT"}
        })
      );
    }
    if (!loading) setSynced(data);
  }, [data, loading, dispatch]);
  return !loading && synced !== undefined;
};
